import { devtools } from "@vue/devtools"
import { defineStore } from "pinia"
import { Log } from "src/util/classes/log"

export interface DevtoolsStoreStoreType {
  devToolsInitiated: boolean
  devToolsHost: string
  devToolsPort: number
}

export const useDevtoolsStore = defineStore("pinia-devtoolsStore", {
  persist: false,

  state: (): DevtoolsStoreStoreType => ({
    devToolsInitiated: false,
    devToolsHost: "localhost",
    devToolsPort: 8098,
  }),

  actions: {
    configureDevtools(host: string, port = 8098) {
      this.devToolsHost = host
      this.devToolsPort = port
    },

    async connectDevtools() {
      if (!this.devToolsInitiated) {
        Log.debug({
          message: "STARTING DEVTOOLS",
          data: { host: this.devToolsHost, port: this.devToolsPort },
        })
        this.devToolsInitiated = true
        await devtools.connect(this.devToolsHost, this.devToolsPort)
      } else {
        Log.warning({ message: "DEVTOOLS ALREADY INITIATED. RESTART APP TO RETRY." })
      }
    },
  },
})
